/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type AiCallLogsQueryVariables = {
    type?: string | null;
    searchQuery?: string | null;
    page?: number | null;
    perPage?: number | null;
};
export type AiCallLogsQueryResponse = {
    readonly aiCallLogList: {
        readonly aiCallLogs: ReadonlyArray<{
            readonly slug: string;
            readonly displayCallType: string;
            readonly entityLabel: string | null;
            readonly entityUrl: string | null;
            readonly model: string;
            readonly status: string;
            readonly failureReason: string | null;
            readonly durationMs: number | null;
            readonly promptTokens: number | null;
            readonly completionTokens: number | null;
            readonly responsePayload: unknown | null;
            readonly createdAt: string;
        }> | null;
        readonly totalCount: number | null;
        readonly paginationMeta: {
            readonly totalPages: number;
        } | null;
    };
};
export type AiCallLogsQuery = {
    readonly response: AiCallLogsQueryResponse;
    readonly variables: AiCallLogsQueryVariables;
};



/*
query AiCallLogsQuery(
  $type: String
  $searchQuery: String
  $page: Int
  $perPage: Int
) {
  aiCallLogList(type: $type, searchQuery: $searchQuery, page: $page, perPage: $perPage) {
    aiCallLogs {
      slug
      displayCallType
      entityLabel
      entityUrl
      model
      status
      failureReason
      durationMs
      promptTokens
      completionTokens
      responsePayload
      createdAt
      id
    }
    totalCount
    paginationMeta {
      totalPages
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "perPage"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchQuery"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v4 = [
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  {
    "kind": "Variable",
    "name": "perPage",
    "variableName": "perPage"
  },
  {
    "kind": "Variable",
    "name": "searchQuery",
    "variableName": "searchQuery"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCallType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityLabel",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "model",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "failureReason",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationMs",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "promptTokens",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completionTokens",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "responsePayload",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Paginate",
  "kind": "LinkedField",
  "name": "paginationMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalPages",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AiCallLogsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "AiCallLogList",
        "kind": "LinkedField",
        "name": "aiCallLogList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AiCallLog",
            "kind": "LinkedField",
            "name": "aiCallLogs",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          (v17/*: any*/),
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AiCallLogsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "AiCallLogList",
        "kind": "LinkedField",
        "name": "aiCallLogList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AiCallLog",
            "kind": "LinkedField",
            "name": "aiCallLogs",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v17/*: any*/),
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c27bd5f196bb20ba6a51939333863ac1",
    "id": null,
    "metadata": {},
    "name": "AiCallLogsQuery",
    "operationKind": "query",
    "text": "query AiCallLogsQuery(\n  $type: String\n  $searchQuery: String\n  $page: Int\n  $perPage: Int\n) {\n  aiCallLogList(type: $type, searchQuery: $searchQuery, page: $page, perPage: $perPage) {\n    aiCallLogs {\n      slug\n      displayCallType\n      entityLabel\n      entityUrl\n      model\n      status\n      failureReason\n      durationMs\n      promptTokens\n      completionTokens\n      responsePayload\n      createdAt\n      id\n    }\n    totalCount\n    paginationMeta {\n      totalPages\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '9e90ffce83c9b660cb5ec75cf3cb93f7';
export default node;
